import type { HomePage } from '../model/HomePage';

export const RPADev: HomePage = {
    name: 'RPADev',
    widgets: [ 'FRE', 'Tenants', 'Automations', 'Runs', 'RecommendationTemplates', 'Actions' ],
    featureFlag: 'HomePage-RPADev',
    persona: 'RPA_DEVELOPER',
};
